// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout__Content__LhJtv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Layout.css
// module id = 132
// module chunks = 3